export const fieldClass =
  "h-11 w-full rounded-control border border-line bg-surface px-3.5 text-sm text-foreground outline-none placeholder:text-muted focus:border-[var(--focus-outline)] focus:ring-1 focus:ring-[var(--focus-outline)] disabled:cursor-not-allowed disabled:opacity-50";

/** A card's look on any element (a section, an article, a list), for when the Card component's div would not do. */
export const cardClass = "rounded-surface border border-line-subtle bg-surface shadow-resting";

/** A multi-line field's look: the field box; its rows set its height. */
export const textareaClass =
  "w-full rounded-control border border-line bg-surface px-3.5 py-2.5 text-sm text-foreground outline-none placeholder:text-muted focus:border-[var(--focus-outline)] focus:ring-1 focus:ring-[var(--focus-outline)] disabled:cursor-not-allowed disabled:opacity-50";

/** A native select's look: the field box. For a long list or a phone's own picker, where the Select component's list would not do. */
export const selectClass = `${fieldClass} pr-8`;
